import React from 'react';
import { State as StateNew } from './State';
import { convertOldStateProps } from './converter.old';
import type { OldStateProps, StateKind } from './converter.old';

export type { StateKind };
export type StateProps = OldStateProps;

export const State = (props: StateProps) => <StateNew {...convertOldStateProps(props)} />;
